var _path, _path2;
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var HuaweiIso = function HuaweiIso(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M25.748 8H15.252C10.308 8 8.5 9.808 8.5 14.752v10.496C8.5 30.192 10.308 32 15.252 32h10.492c4.944 0 6.756-1.808 6.756-6.752V14.752C32.5 9.808 30.692 8 25.748 8Z",
      fill: "#C91C2E"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M18.97 21.92h.963l-.483-1.124-.48 1.123Zm-.236.565-.286.653h-.65l1.383-3.136h.561l1.377 3.136h-.667l-.282-.653h-1.436Zm10.46.651h.628v-3.134h-.629v3.134Zm-2.5-1.346h1.157v-.572h-1.158v-.642h1.68v-.572h-2.308v3.134h2.37v-.572h-1.742v-.776Zm-2.497.37-.713-2.158h-.519l-.712 2.158-.694-2.156h-.677l1.093 3.136h.527l.714-2.06.713 2.06h.532l1.09-3.136h-.66l-.694 2.156Zm-7.358-.362c0 .51-.253.783-.713.783-.463 0-.718-.28-.718-.805v-1.772h-.636v1.794c0 .883.49 1.389 1.345 1.389.863 0 1.359-.516 1.359-1.415v-1.77h-.637v1.796Zm-3.586-1.796h.636v3.138h-.636v-1.274h-1.438v1.274h-.636v-3.138h.636v1.266h1.438v-1.266ZM20.5 16.007a4 4 0 0 1-3.995-3.995h.565a3.434 3.434 0 0 0 3.43 3.43 3.434 3.434 0 0 0 3.43-3.43h.565a4 4 0 0 1-3.995 3.995Z",
      fill: "#fff"
    }))]
  });
};
export default HuaweiIso;